import {
    callV3,
    formatLonghandDateTimeWithWeekday,
    formatRelativeDate,
    formatLonghandDateTimeNoYear,
} from '@modernanimal/common';
import * as Sentry from '@sentry/react';
import { isEqual, startCase } from 'lodash';

import {
    PATCH_CLIENT, CREATE_CREDIT_CARD, CREATE_APPOINTMENT
} from './clientOnboarding.v3.gql';
import {
    PatchClientMutation,
    PatchClientMutationVariables,
    ClientInputPartial,
    CreateCreditCardMutation,
    CreateCreditCardMutationVariables,
    CreditCardInput,
    CreateAppointmentMutation,
    CreateAppointmentMutationVariables,
    AppointmentInput,
} from '../__generated__/graphql';
import { ClientStoreType } from '../store';

export const patchClient = async (token: string, input: ClientInputPartial) => {
    try {
        const resp = await callV3<PatchClientMutation, PatchClientMutationVariables>(
            token,
            'client',
            PATCH_CLIENT,
            { input }
        );
        return resp.data.patchClient;
    } catch (err) {
        console.error('Error in patchClient:', err);
        Sentry.captureException(err, {
            extra: {
                input,
                path: 'src/clientOnboarding/clientOnboarding.helpers',
                function: 'patchClient'
            },
        });
        throw err;
    }
};

export const createCreditCard = async (token: string, input: CreditCardInput) => {
    try {
        const resp = await callV3<CreateCreditCardMutation, CreateCreditCardMutationVariables>(
            token,
            'client',
            CREATE_CREDIT_CARD,
            { input }
        );
        return resp.data.createCreditCard;
    } catch (err) {
        console.error('Error in createCreditCard:', err);
        Sentry.captureException(err, {
            extra: {
                input,
                path: 'src/clientOnboarding/clientOnboarding.helpers',
                function: 'createCreditCard'
            },
        });
        throw err;
    }
};

export const createAppointment = async (token: string, input: AppointmentInput) => {
    try {
        const resp = await callV3<CreateAppointmentMutation, CreateAppointmentMutationVariables>(
            token,
            'client',
            CREATE_APPOINTMENT,
            { input }
        );
        return resp.data.createAppointment;
    } catch (err) {
        console.error('Error in createAppointment:', err);
        Sentry.captureException(err, {
            extra: {
                input,
                path: 'src/clientOnboarding/clientOnboarding.helpers',
                function: 'createAppointment'
            },
        });
        throw err;
    }
};

export const isClientEdited = (
    existingClient: ClientStoreType,
    newClient: ClientStoreType
) => !isEqual(existingClient, newClient);

export const formatRelativeAppointmentDatetime = (datetime: string, timezone: string) => {
    const relativeCalendarFormat = formatRelativeDate(datetime, timezone, true);
    if (relativeCalendarFormat === 'today' || relativeCalendarFormat === 'tomorrow') {
        return `${startCase(relativeCalendarFormat)}, ${formatLonghandDateTimeNoYear(datetime, timezone)}`;
    }

    return formatLonghandDateTimeWithWeekday(datetime, timezone);
};
